import axios from 'axios';

// Arayüz API ile aynı adresten sunulduğu için varsayılan göreli yol yeterli
const API_URL = process.env.REACT_APP_API_URL || '/api';

// Socket.io sunucusu API ile aynı origin'de çalışır
export const SOCKET_URL = /^https?:\/\//.test(API_URL) ? new URL(API_URL).origin : undefined;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor - Token ekle
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Hata yönetimi
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me')
};

// Business API
export const businessAPI = {
  getAll: (params) => api.get('/businesses', { params }),
  getOne: (id) => api.get(`/businesses/${id}`),
  scrape: (data) => api.post('/businesses/scrape', data),
  getScrapeStatus: () => api.get('/businesses/scrape/status'),
  cancelScrape: () => api.post('/businesses/scrape/cancel'),
  refresh: (data) => api.post('/businesses/refresh', data),
  update: (id, data) => api.put(`/businesses/${id}`, data),
  delete: (id) => api.delete(`/businesses/${id}`),
  getFilterOptions: () => api.get('/businesses/filters/options'),
  getDistricts: (city) => api.get(`/businesses/filters/districts/${city}`)
};

// Campaign API
export const campaignAPI = {
  getAll: () => api.get('/campaigns'),
  getOne: (id) => api.get(`/campaigns/${id}`),
  getMeta: () => api.get('/campaigns/meta'),
  getAudience: (data) => api.post('/campaigns/audience', data),
  preview: (data) => api.post('/campaigns/preview', data),
  sendTest: (data) => api.post('/campaigns/test', data),
  create: (data) => api.post('/campaigns', data),
  update: (id, data) => api.put(`/campaigns/${id}`, data),
  getRecipients: (id, params) => api.get(`/campaigns/${id}/recipients`, { params }),
  send: (id) => api.post(`/campaigns/${id}/send`),
  cancel: (id) => api.post(`/campaigns/${id}/cancel`),
  retry: (id) => api.post(`/campaigns/${id}/retry`),
  duplicate: (id) => api.post(`/campaigns/${id}/duplicate`),
  delete: (id) => api.delete(`/campaigns/${id}`)
};

// Messaging API
export const messagingAPI = {
  whatsapp: {
    getStatus: () => api.get('/messaging/whatsapp/status'),
    initialize: () => api.post('/messaging/whatsapp/initialize'),
    logout: () => api.post('/messaging/whatsapp/logout')
  },
  telegram: {
    getStatus: () => api.get('/messaging/telegram/status'),
    initialize: () => api.post('/messaging/telegram/initialize')
  }
};

// Config API
export const configAPI = {
  getConfig: () => api.get('/config'),
  updateTelegram: (data) => api.put('/config/telegram', data),
  getEmailAccounts: () => api.get('/config/email-accounts'),
  createEmailAccount: (data) => api.post('/config/email-accounts', data),
  updateEmailAccount: (id, data) => api.put(`/config/email-accounts/${id}`, data),
  setDefaultEmailAccount: (id) => api.post(`/config/email-accounts/${id}/default`),
  deleteEmailAccount: (id) => api.delete(`/config/email-accounts/${id}`),
  testEmailAccount: (id, to) => api.post(`/config/email-accounts/${id}/test`, { to }),
  testTelegram: (data) => api.post('/config/telegram/test', data),
  getSignatures: () => api.get('/config/signatures'),
  createSignature: (data) => api.post('/config/signatures', data),
  updateSignature: (id, data) => api.put(`/config/signatures/${id}`, data),
  setDefaultSignature: (id) => api.post(`/config/signatures/${id}/default`),
  deleteSignature: (id) => api.delete(`/config/signatures/${id}`),
  previewSignature: (signature) => api.post('/config/signature/preview', { signature }),
  uploadLogo: (dataUrl) => api.post('/config/signature/logo', { dataUrl })
};

export default api;